import React, { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { SmartlistType } from "../../api/MediaAPI.types";
import CreateButton from "../common/CreateButton";
import GenericSmartlistList from "../common/smartlist/GenericSmartlistList";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

function SmartlistCollectionsList(): JSX.Element {
  const { t } = useTranslation("editor-smartlist");
  const getDeleteBody = useCallback(
    (label: string): string => t("deleteBodyCollection", { smartlist: label }),
    [t],
  );
  const { projectSlug } = useParams<{ projectSlug: string }>();

  const breadcrumbs = [
    {
      name: t("editor-menu:publishing-management"),
      url: "/collections",
    },
    {
      name: t("sectionTitleCollections"),
    },
  ];

  const createButton = (
    <CreateButton
      href={`${PROJECTS_ROUTE}/${projectSlug}/collections/new/`}
      label={t("createSmartlistCollection")}
    />
  );

  return (
    <GenericSmartlistList
      breadcrumbs={breadcrumbs}
      createButton={createButton}
      deleteCompleteText={t("deleteCompleteCollection")}
      deleteTitle={t("deleteTitleCollection")}
      editUrlPrefix="collections"
      getDeleteBody={getDeleteBody}
      smartlistTypes={SmartlistType.COLLECTION}
      tableTitle={t("sectionTitleCollections")}
    />
  );
}

export default SmartlistCollectionsList;
